import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import CommonSlider from "components/common-slider";
import Stars from "components/stars";
import Review from "./review";

const settings = {
    className: "common-slider static-reviews-slider",
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 990,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

const Reviews = ({ data: { title, reviews } }) => (
    <div className="flex flex-col w-full">
        <div className="container flex-row">
            <div className="pb-5 pt-11">
                <h3 className="text-blue-700 mb-2 text-center"> 
                    {title}
                </h3>
                <Stars rating={5} className="justify-center" />
            </div>
            <CommonSlider settings={settings}>
                {reviews?.map((review) => (
                    <Review key={review._key} review={review} />
                ))}
            </CommonSlider>
        </div>
    </div>
);

export default Reviews;
